import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledFieldInlineEdit = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--field-inline-edit-min-width': utils.isDefined(props.$minWidth) ? props.theme.layout(props.$minWidth) : null,
      '--field-inline-edit-max-width': utils.isDefined(props.$maxWidth) ? props.theme.layout(props.$maxWidth) : null
    };

    return utils.styleProps(attr, vars);
  })`
  > .Icon, > .Logo {
    margin-right: ${props => props.theme.layout('1sp')};
  }

  &.FieldInlineEdit {
    max-width: ${props => props.theme.layout(320)};
    max-height: min(${props => props.theme.layout(300)}, 46vh);
    
    &:has(.SuggestionField) {
      max-width: unset;
    }
    
    &:has(.TextField-multiline) {
      max-width: ${props => props.theme.layout(500)};
    }
    
    &:has(.CloudField) {
      overflow: hidden;
    }

    ${props => utils.isDefined(props.$minWidth) ? css`
      max-width: unset;
      min-width: ${props.$css.$var('--field-inline-edit-min-width', false)} !important;
    ` : css``}

    ${props => utils.isDefined(props.$maxWidth) ? css`
      max-width: ${props.$css.$var('--field-inline-edit-max-width', false)} !important;
    ` : css``}
  }
  
  .Form {
    padding: ${props => props.theme.spacing(2)};
    &:has(.ListField) {
      padding: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(2)};
    }
    
    .Form-fields {
      height: 100%;
      row-gap: ${props => props.theme.layout('1sp')};
      
      .FormField {
        min-width: ${props => props.theme.layout(244)};
        
        &.ListField {
          &:not(.ListField-showSearch) {
            min-width: unset;
          }
        }

        &.SuggestionField {
          min-width: ${props => props.theme.layout(374)};
        }

        &.TextField-multiline {
          min-width: ${props => props.theme.layout(374)};
        }

        &.CloudField {
          max-width: ${props => props.theme.layout(374)};
          min-width: ${props => props.theme.layout(374)};
        }
      }
    }
  }
  
  .MuiFormControl-root {
    position: relative;
    &.CheckboxField, &.SwitchField {
      .FormControlLabel {
        margin-left: ${props => props.theme.layout(-8)};
      }  
      .Checkbox {
        padding: ${props => props.theme.layout(6)};
        svg {
          font-size: ${props => props.theme.fontSize(20)};
        }
      }
      .MuiFormHelperText-root:has(*) {
        bottom: ${props => props.theme.layout(-12)};
      }
    }
    
    .MuiFormHelperText-root:has(*) {
      display: flex;
      width: 100%;
      bottom: ${props => props.theme.layout(-14)};
      height: ${props => props.theme.layout(16)};

      > * {
        width: 1px;
        flex-grow: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        p {
          display: contents;
        }
      }
    }
  }
  ${ComponentStyles}
`;

StyledFieldInlineEdit.propTypes = {
  theme: PropTypes.object
};

export default StyledFieldInlineEdit;
